// componente per la visualizzazione della pagina di inserimento/modifica di un pannello (componente sinistra)
// nella pagina "Pannelli"

import { Component, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/service/alert.service';

import { ApiService } from '../../../../service/api.service';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';

import { Groups } from '../groups.model';
import { GroupsService } from '../groups.service';
import { GroupsListComponent } from '../groups-list/groups-list.component';

@Component({
  selector: 'app-groups-edit',
  templateUrl: './groups-edit.component.html',
  styleUrls: ['./style.scss']
})
export class GroupsEditComponent implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) groupsForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode = false; // variabile posta a true se è attiva la modifica di un pannello
  oldId = 0; // ID del pannello prima della modifica
  editGroupsId = 0; // ID del pannello da modificare
  groups: Groups; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  bodies
  emailAlredyExist = "";
  cards = []
  constructor(private als: AlertService, private groupsService: GroupsService, private groupsList: GroupsListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.groupsForm.value.groupid)) {
      this.emailAlredyExist = "ID gruppo già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this
    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v
    })
    this.dataStorageService.getGroupsTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.groupid)
      })
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    this.bodyid = this.auth.currentUserValue.bodyid

    // si riempie la form coi valori preimpostati
    this.subscription = this.groupsService.groupsEditMode.subscribe(
      (id: number) => {
        me.groups = me.groupsService.getGroupsByIndex(id);
        me.oldId = me.groups.id
        if (me.profile == 'SuperAdmin') {
          me.groupsForm.setValue({
            groupid: me.groups.groupid ? me.groups.groupid : "",
            description: me.groups.description ? me.groups.description : "",
            bodyid: me.groups.bodyid ? me.groups.bodyid : "",
            tag: me.groups.tag ? me.groups.tag : "",
          });
        } else {
          me.groupsForm.setValue({
            groupid: me.groups.groupid ? me.groups.groupid : "",
            description: me.groups.description ? me.groups.description : "",
            tag: me.groups.tag ? me.groups.tag : "",
          });
        }

        me.editGroupsId = id;
        me.editMode = true;
      }
    );
  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var body
    me.profile == 'SuperAdmin' ? body = value.bodyid : body = undefined

    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxGroups().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Groups(v,
          value.groupid,
          value.description,
          body,
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeGroups(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.groups = mess;
        me.groupsService.addGroups(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_groups = new Groups(me.oldId,
        value.groupid,
        value.description,
        body,
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.groups = new_groups;
      me.groups.id = me.editGroupsId;
      var res = this.groupsList.getIndex(this.groups.id)
      me.groupsService.updateGroups(res, me.groups);
      me.groups.id = me.oldId

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateGroups(me.groups)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    var me = this
    if (me.profile == 'SuperAdmin') {
      this.groupsForm.setValue({
        groupid: '',
        description: '',
        bodyid: '',
        tag: ''
      });
    } else {
      this.groupsForm.setValue({
        groupid: '',
        description: '',
        tag: ''
      });
    }
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm('Sei sicuro di voler eliminare il gruppo?').subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteGroups(me.groups.id)

        // ...il messaggio viene eliminato dalla tabella...
        me.groupsService.deleteGroups(me.groups.id);

        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;

        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }
  import() {
    var me = this
    const dialogRef = this.dialog.open(Upload5, {});
    dialogRef.afterClosed().subscribe(result => {
      me.dataStorageService.getGroups();
      me.utilsService.hideLoader();
    });
  }
}

@Component({
  selector: 'upload',
  templateUrl: 'file-upload.component.html',
  styleUrls: ['./style.scss']
})
export class Upload5 implements OnInit {

  constructor(public dialogRef: MatDialogRef<Upload5>,
    public dataStorageService: ApiService, private utilsService: UtilsService) { }
  fileToUpload: File = null;
  jsontosave
  loaded
  ngOnInit() {

  }
  handleFileInput(files: FileList) {
    var me = this
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: string = reader.result as string;
        me.jsontosave = me.csvJSON(csv)
        me.loaded = true
      }
    }
  }
  uploadFileToActivity() {
    var me = this
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (this.readyState == 4 && (this.status == 200 || this.status == 500)) {
        me.dialogRef.close();
      }
    };
    xmlHttp.open("POST", 'https://sosimperium.multiutilitydelgarda.eu:8001/csvgroups', false); // false for synchronous request
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.send(this.jsontosave);
    me.loaded = false
    // this.dataStorageService.storeCsvGroups(this.jsontosave)
  }

  csvJSON(csv) {
    var lines = csv.split("\n");
    var result = [];
    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {

      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        if (headers[j] && currentline[j]) {
          headers[j] = headers[j].replace(/[\n\r]+/g, '');
          currentline[j] = currentline[j].replace(/[\n\r]+/g, '');
          obj[headers[j]] = currentline[j];
        }
      }

      result.push(obj);

    }
    return JSON.stringify(result); //JSON
  }
}